<template>
  <section class="sale-payment-plan-summary-card card">
    <div class="card-body sale-payment-plan-summary-body">
      <div class="sale-payment-plan-summary-metrics">
        <article
          v-for="section in summarySections"
          :key="section.key"
          class="sale-payment-plan-summary-metric"
          :class="`sale-payment-plan-summary-metric--${section.key}`"
        >
          <div class="sale-payment-plan-summary-metric-head">
            <h4>{{ section.title }}</h4>
          </div>

          <div class="sale-payment-plan-summary-breakdown">
            <div class="sale-payment-plan-summary-breakdown-item sale-payment-plan-summary-breakdown-item--subtotal">
              <small>{{ text.summary.breakdown.subtotal }}</small>
              <strong>{{ section.values.subtotal }}</strong>
            </div>

            <div class="sale-payment-plan-summary-breakdown-item sale-payment-plan-summary-breakdown-item--transferred">
              <small>{{ text.summary.breakdown.transferredTaxes }}</small>
              <strong>{{ section.values.transferred_taxes }}</strong>
            </div>

            <div class="sale-payment-plan-summary-breakdown-item sale-payment-plan-summary-breakdown-item--withheld">
              <small>{{ text.summary.breakdown.withheldTaxes }}</small>
              <strong>{{ section.values.withheld_taxes }}</strong>
            </div>

            <div class="sale-payment-plan-summary-breakdown-item sale-payment-plan-summary-breakdown-item--total">
              <small>{{ text.summary.breakdown.total }}</small>
              <strong>{{ section.values.total }}</strong>
            </div>
          </div>
        </article>
      </div>

      <div class="sale-payment-plan-summary-actions">
        <button
          type="button"
          class="app-header-btn app-header-btn--secondary"
          @click="$emit('clear')"
        >
          <i class="fa fa-eraser" aria-hidden="true"></i>
          <span>Limpiar</span>
        </button>

        <button
          type="button"
          class="app-header-btn app-header-btn--primary"
          @click="$emit('new-payment-plan')"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span>Plan de pagos</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('payments');

export default {
  name: 'SalePaymentPlanSummary',
  props: {
    summary: {
      type: Object,
      default: () => ({
        payment_plan: {
          subtotal: '$0.00',
          transferred_taxes: '$0.00',
          withheld_taxes: '$0.00',
          total: '$0.00',
        },
        paid: {
          subtotal: '$0.00',
          transferred_taxes: '$0.00',
          withheld_taxes: '$0.00',
          total: '$0.00',
        },
        pending: {
          subtotal: '$0.00',
          transferred_taxes: '$0.00',
          withheld_taxes: '$0.00',
          total: '$0.00',
        },
      }),
    },
  },
  emits: ['clear', 'new-payment-plan'],
  data() {
    return {
      text,
    };
  },
  computed: {
    summarySections() {
      return [
        {
          key: 'payment-plan',
          title: this.text.summary.sections.paymentPlan,
          values: this.summary?.payment_plan || {},
        },
        {
          key: 'paid',
          title: this.text.summary.sections.paidDone || 'Ya pagado',
          values: this.summary?.paid || {},
        },
        {
          key: 'pending',
          title: this.text.summary.sections.pendingToPay || 'Pendiente por pagar',
          values: this.summary?.pending || {},
        },
      ];
    },
  },
};
</script>

<style scoped>
.sale-payment-plan-summary-card {
  border: 1px solid rgba(153, 152, 153, 0.24);
  border-top: 2px solid #00b2e2;
  border-radius: 9px;
  box-shadow: 0 3px 12px rgba(0, 98, 163, 0.08);
  background: #ffffff;
  margin: 0;
}

.sale-payment-plan-summary-card .sale-payment-plan-summary-body {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 8px;
  padding: 8px !important;
}

.sale-payment-plan-summary-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  flex: 1;
}

.sale-payment-plan-summary-metric {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 6px 8px;
  min-height: 76px;
  justify-content: center;
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.85), #ffffff);
}

.sale-payment-plan-summary-metric-head {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.sale-payment-plan-summary-metric h4 {
  margin: 0;
  color: #1f2937;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}

.sale-payment-plan-summary-breakdown {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.sale-payment-plan-summary-breakdown-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  min-width: 0;
  padding: 3px 0;
  border: 0;
}

.sale-payment-plan-summary-breakdown-item small {
  color: #334155;
  font-size: 9px;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.sale-payment-plan-summary-breakdown-item strong {
  color: #0f172a;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.1;
  white-space: nowrap;
}

.sale-payment-plan-summary-breakdown-item--subtotal strong {
  color: #111827;
}

.sale-payment-plan-summary-breakdown-item--transferred strong {
  color: #64748b;
}

.sale-payment-plan-summary-breakdown-item--withheld strong {
  color: #64748b;
}

.sale-payment-plan-summary-breakdown-item--total strong {
  color: #0b5394;
}

.sale-payment-plan-summary-breakdown-item--total {
  border-top: 1px solid rgba(148, 163, 184, 0.45);
  margin-top: 2px;
  padding-top: 5px;
}

.sale-payment-plan-summary-metric--paid h4 {
  color: #166534;
}

.sale-payment-plan-summary-metric--pending h4 {
  color: #b91c1c;
}

.sale-payment-plan-summary-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
}

.sale-payment-plan-summary-actions .app-header-btn {
  min-height: 36px;
}

@media (max-width: 991px) {
  .sale-payment-plan-summary-metrics {
    grid-template-columns: 1fr;
  }

  .sale-payment-plan-summary-actions {
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}

@media (max-width: 767px) {
  .sale-payment-plan-summary-breakdown-item strong {
    font-size: 12px;
  }
}
</style>
